/**
 * @author chenwj
 * @date 2021/06/09 14:27
 */

import store from '../store'
import request from '../config/network/requestUcenterApiService'
import {isNull} from "../utils/utils"
//import {Message,MessageBox } from 'element-ui';
import {MessageBox } from 'element-ui';

// 修改课件
export async function apiUpdate (data,id) {//新数据，数据ID，数据类型，不加锁直接提交
  if(data.method=="put"){
    console.log("PUT，直接提交网络；");
    return request(data);
  }
  
  let thisId=(store.state.initConfig.is_practice)?store.state.initConfig.practice_id:store.state.initConfig.id;
  if(isNull(thisId))(store.state.initConfig.is_practice)?store.state.initConfig.practice_id=id:store.state.initConfig.id=id;

  if(data.noLock || isNull(data.data.actions)){//不加锁链接请求，条件为未操作编辑数据
    return request(data);
  }else{
    //开始处理是否当前数据与缓存数据一致，不一致直接提交；
    let api_lock=localStorage.getItem("api_lock");
    let api_data_cache=localStorage.getItem("api_data_cache");

    if(api_lock!="0" && !isNull(api_data_cache)){//当ID锁不等0或本地缓存不等于空时，进入本地数据模式
      //console.log("开始保存本地储存：",data);
      let api_data=localStorage.getItem("api_data");//获取本地数据
      if(isNull(api_data)){//空数据情况，直接保存
        api_data=data;
      }else{
        api_data=JSON.parse(api_data);//转换为json格式

        if(api_data.url!=data.url){//如果url不相等，直接提交网络
          store.state.notice={ico:"el-icon-error",state:true,info:"当前数据不是本地缓存数据，已直接提交网络；"};
          return request(data);
        }

        /*此为去重方法*/for (var i in api_data.data.actions) {
          if(api_data.data.actions[i].operation=="edit" && data.data.actions[0].operation=="edit"){
            //console.log("开始查找数据：",api_data[id].data.actions[i],data.data.);
            if(api_data.data.actions[i].toUnique==data.data.actions[0].toUnique){
              api_data.data.actions.splice(i, 1);
              //console.log("已经查到相同数据：",api_data[id].data.actions);
            }
          }
        }/**/

        api_data.data.actions=api_data.data.actions.concat(data.data.actions);//数据去重处理并将数据完整存入本地；
      }
      localStorage.setItem("api_data",JSON.stringify(api_data));//操作已经成功缓存临时队列
      store.commit('setUpdateState', "已离线保存")

      //开始处理本地缓存数据未提交成功重试请求
      api_data_cache=JSON.parse(api_data_cache)
      let times=(new Date()).valueOf()-api_data_cache.time;
      if(times>30000){//设置url相同时超时30秒，不同时5秒；
        //console.log("设置url相同时超时30秒，不同时5秒；",times)
        return api_cache("err",1)
      }
      
      if(api_data.data.actions.length>=10){
        store.state.notice={ico:"el-icon-error",state:true,info:"当前存在多个离线数据，等待网络恢复后继续编辑；"};
        store.commit('setUpdateState', '网络不稳定，已离线保存；')
      }
      return {"status_code":200};
    }else{
      //console.log("直接提交网络，当前不保存本地：",data);
      if(api_lock!=id && api_lock!="0" && !isNull(api_lock)){//不是当前窗口操作，将直接提交网络不缓存；
        //console.log("不是当前窗口操作，将直接提交网络不缓存；");
        store.state.notice={ico:"el-icon-error",state:true,info:"有编辑器在上传数据，本操作直接上传，并等待其他操作完成；"};
        return request(data);
      }
      data.time=(new Date()).valueOf();
      data.id=id;
      localStorage.setItem("api_data_cache",JSON.stringify(data));//进入缓存数据，直到成功后清除；
      localStorage.setItem("api_lock",id);//加锁解除处理并提交链接：
      store.commit('setUpdateState', "保存中…");
      return api_request(data);
    }
  }
}

/*
  成功后，将本地数据提交至网络
*/
export async function api_local(){
  let api_data=localStorage.getItem("api_data");
  localStorage.setItem("api_data","");//清除本地保存数据
  localStorage.setItem("api_data_cache",api_data);//将本地数据保存至本地缓存，在提交
  return api_request(JSON.parse(api_data),1);
}

/*
  失败后，重新提交数据
*/
export async function api_cache(){
  let api_data_cache=localStorage.getItem("api_data_cache");
  if(isNull(api_data_cache))return api_local();//空数据情况，走本地数据
  let data=JSON.parse(api_data_cache)
  data.time=(new Date()).valueOf();
  localStorage.setItem("api_data_cache",JSON.stringify(data));//更新本地缓存提交时间
  return await api_request(data);
}

//更新提交操作数据；
export async function api_request(data){
  if(!isNull(data.data.actions) && data.method!="put"){//开始过滤空数据
    for(let i=0;i<data.data.actions.length;i++) {
      if(isNull(data.data.actions[i])){
        console.log("已经过滤：",data.data.actions[i]);
        data.data.actions.splice(i,1);
      }
    }
  }
  localStorage.setItem("api_state","0");//api网络状态，0：未成功，1：已成功
  request(data).then(res=>{
    //链接处理完成，并且提交最新本地数据：
    //console.log("提交网络中,提交已经成功：",res,data);
    store.commit('setUpdateState', "已全部保存至云端")
    if(res.status_code==200){
      localStorage.setItem("api_state","1");
      //console.log("本地首要缓存数据已经提交成功；准备提交本地全部数据；",data);
      localStorage.setItem("api_data_cache","");//清除本地缓存保存数据
      store.state.notice={ico:"",state:false,info:""};
      let api_data=localStorage.getItem("api_data");
      if(isNull(api_data))localStorage.setItem("api_lock","0");//解除锁定更新
      let thisId=(store.state.initConfig.is_practice)?store.state.initConfig.practice_id:store.state.initConfig.id;
      if(res.code==201 && thisId==data.id){
        MessageBox.alert(res.message, '提示', {
          confirmButtonText: '确定关闭页面',
          callback: action => {
            console.log(action);
            window.close();
          }
        });
      }
      return (isNull(api_data))?res:api_local();
    }else{
      //失败情况下，将重新提交上传
      store.state.notice={ico:"el-icon-error",state:true,info:"您的网络连接超时，数据已保存本地，需等待网络恢复后继续编辑"};
    }
    return res;
  }).catch(err=>{
    //失败情况下，将重新提交上传
    //console.log("提交网络中,提交已经失败：",err);
    store.commit('setUpdateState', "网络不稳定，已离线保存");
    console.log("网络报错：",err);
    store.state.notice={ico:"el-icon-error",state:true,info:"您的网络连接超时，数据已保存本地，需等待网络恢复后继续编辑"};
    //Message.success(err.message)
    return err;
  });
}
export async function api_save_request(reload){  
  let api_data_cache=localStorage.getItem("api_data_cache");
  let api_data=localStorage.getItem("api_data");
  if(!isNull(api_data_cache) && !isNull(api_data)){
    let dataCacheArr=JSON.parse(api_data_cache);
    let dataArr=JSON.parse(api_data);
    if(dataCacheArr.method!="put" && dataCacheArr.method==dataArr.method && dataCacheArr.url==dataArr.url){//如果提交类型一致，或链接一致
      console.log("提交类型与提交链接一致，合并提交数据");
      dataCacheArr.data.actions=dataCacheArr.data.actions.concat(dataArr.data.actions);//数据合并处理；
      api_data_cache=JSON.stringify(dataCacheArr);
      localStorage.setItem("api_data","");//清除本地保存数据
      localStorage.setItem("api_data_cache",api_data_cache);//将本地数据保存至本地缓存，在提交
      api_data=api_data_cache;
      store.state.notice={ico:"el-icon-error",state:true,info:"您本地存在未提交缓存，正在保存中，请稍等..."};
    }
  }
  if(isNull(api_data_cache)){
    store.state.notice={ico:"",state:false,info:""};
  }else{
      store.state.notice={ico:"el-icon-error",state:true,info:"您本地存在未提交缓存，正在保存中，请稍等..."};
      let res= await api_cache("err");
      api_time(res,reload);
  }
}

export function api_time(res,reload){
  //console.log("查询是否成功：",res);
  let apiDataCache=localStorage.getItem("api_data_cache");
  let apiData=localStorage.getItem("api_data");
  let api_state=localStorage.getItem("api_state");
  let isCacheSave=(isNull(apiDataCache) && isNull(apiData))?1:0;
  if(isCacheSave || api_state=="1"){
      //console.log("查询成功：重新加载数据");
      store.state.notice={ico:"",state:false,info:""};
      if(reload && api_state=="1")window.location.reload();//强制刷新页面
      if(reload)setTimeout(() => {window.location.reload()}, 15000);//强制刷新页面，定时15秒后刷新；
  }else{
      setTimeout(() => {
        api_time(res,reload);
      }, 1000);
  }
  return reload;
}